<template>
  <div class="container">
    <div :class="{ main: data.userId, 'main-m': !data.userId }">
      <div class="header">
        <div class="mask-ctn">
          <div id="aPlayer" />
          <img
            v-bind:style="{
              width: screenWidth + 'px',
              height: screenHeigth + 'px',
            }"
            v-if="finished"
            :src="data.cover_url"
            class="cover"
          />
          <div v-if="finished" class="mask">
            <p class="buy-text">购买后可继续观看</p>
          </div>
        </div>
        <img v-if="!data.video_id" :src="data.cover_url" class="cover" />
        <div class="vr-info-ctn">
          <p class="price">
            限时抢购
            <span class="unit">￥</span>
            <span class="current">{{ data.selling_price }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="origin">原价{{ data.original_price }}</span>
          </p>
          <p class="vr-title">
            {{ data.title }}<span class="trail-text">(试看2分钟)</span>
          </p>
          <p class="author">{{ data.sub_title }}</p>
        </div>
        <ControlBar
          v-if="data.videos"
          :videos="data.videos"
          :onSection="onVideo"
        />
      </div>
      <div class="intro" v-if="data.selling_introduction">
        <div class="content-header">
          <p>课程介绍</p>
        </div>
        <div id="content" v-html="data.selling_introduction" />
      </div>
      <Comment
        v-if="data.comments && data.comments.length > 0"
        :comments="data.comments"
      />
    </div>
    <div @click="onDownload" v-if="!data.userId" class="download-button">
      下载培伴App
    </div>
  </div>
</template>

<script>
import polyvPlayer from 'polyvPlayer';
import Comment from './Comment';
import ControlBar from './ControlBar';

export default {
  name: 'Purchase',
  components: {
    Comment,
    ControlBar,
  },
  data() {
    return {
      finished: false,
      screenWidth: Math.min(window.innerWidth, 1024),
      screenHeigth: (Math.min(window.innerWidth, 1024) * 480) / 854,
    };
  },
  props: {
    data: Object,
    onDownload: Function,
  },
  mounted() {
    const screenWidth = Math.min(window.innerWidth, 1024);
    if (this.data.video_id) {
      this.player = polyvPlayer({
        wrap: '#aPlayer',
        width: screenWidth,
        height: (screenWidth * 480) / 854,
        vid: this.data.video_id,
        forceH5: true,
        watchEndTime: 120,
        hideSwitchPlayer: true,
        ban_seek_by_limit_time: 'on',
        ban_history_time: 'on',
        ban_seek: 'on',
        allowFullscreen: false,
        showHd: false,
      });
      window.s2j_onPlayOver = () => {
        this.finished = true;
      };
    }
  },
  methods: {
    onClick() {},
    onVideo(vid) {
      this.finished = false;
      this.player.changeVid({ vid, watchEndTime: 120 });
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  align-items: center;
  max-width: 1024px;
  position: relative;
}

p {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  font-family: sans-serif;
}

.main-m {
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  font-family: sans-serif;
  margin-bottom: 40px;
  margin-bottom: calc(40px + env(safe-area-inset-bottom));
  margin-bottom: calc(40px + constant(safe-area-inset-bottom));
}

#content {
  padding: 15px 15px 10px 15px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  margin: 0 !important;
  text-align: justify !important;
}

#content >>> img {
  width: 100% !important;
  height: auto !important;
}

.header {
  width: 100%;
  background-color: white;
}

.vr-info-ctn {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
}

.price {
  font-size: 16px;
  color: #999;
}

.price > .current {
  font-size: 20px;
  color: #f24a4a;
  font-weight: 500;
}

.price > .unit {
  color: #f24a4a;
}

.price > .origin {
  text-decoration: #999 line-through;
}

.vr-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-top: 4px;
  text-align: justify;
}

.author {
  font-size: 16px;
  color: #898989;
  margin-top: 6px;
}
.intro {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  background-color: #fff;
  width: 100%;
}

.content-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border-bottom: #f5f5f5 solid 1px;
  background-color: #fff;
}

.content-header > p {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  width: 100%;
}

#content {
  padding: 10px 15px 0 15px;
  box-sizing: border-box;
  background-color: #fff;
  font-family: sans-serif !important;
}

#content >>> img {
  width: 100% !important;
}

.cover {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: auto;
  z-index: 10000;
}

#player {
  z-index: 1000;
}

.mask-cover {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.mask-ctn {
  position: relative;
}

.mask {
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100000000;
  line-height: 100%;
  justify-content: center;
  align-items: center;
}

.buy-text {
  color: #fff;
}

.trail-text {
  color: #999;
}

.download-button {
  position: fixed;
  height: 40px;
  background-color: #49afad;
  text-align: center;
  color: white;
  line-height: 40px;
  width: inherit;
  max-width: 1024px;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
